import Toast from '../../../component/toast';

export const toPage = (text: string) => {
  Toast(text);
};
